import { render, staticRenderFns } from "./book-selector-search.component.vue?vue&type=template&id=af508886"
import script from "./book-selector-search.component.vue?vue&type=script&lang=ts"
export * from "./book-selector-search.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports